export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Maintenance technicians, facility maintenance workers, building maintenance professionals, property maintenance teams and general maintenance staff.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. MAINTENANCE READY™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer:
      'No. It is a practical professional maintenance reference and organization system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on ready-to-use workflows, checklists, maintenance records, work-order tools and control resources.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Preventive maintenance, inspections, troubleshooting, work orders, asset records and maintenance control.',
  },
  {
    question: 'Does this replace professional procedures or manufacturer instructions?',
    answer:
      'No. Always follow manufacturer documentation, professional safety procedures and applicable workplace requirements.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Do I need experience to use it?',
    answer:
      'No special background is required. The workflows, checklists and templates are written in plain language and can be used from the first day, whether you handle one building or a full site.',
  },
  {
    question: 'Can I print the checklists and work orders?',
    answer:
      'Yes. Every checklist, work-order template, record sheet and tracker is designed to be printed and used in the field, or kept digitally on a phone or tablet.',
  },
  {
    question: 'Can my whole maintenance team use it?',
    answer:
      'Yes. The system is built to standardize how a team inspects, prioritizes, documents and hands over work, so everyone follows the same maintenance process.',
  },
]
